import { Delegate } from './delegate';

export class CMUser {
  DelegatedUsers: Array<Delegate> = [];
  MyDelegations: Array<Delegate> = [];
  CurrentDelegation: Delegate;

  constructor() {}
}
